import {CardColor} from "./api/CardColor";
import {CardName} from "./api/CardName";

export class Card {

    private color: CardColor;
    private name: CardName;
    private value: number;

    constructor(color: CardColor, name: CardName, value: number) {
        this.color = color;
        this.name = name;
        this.value = value;
    }

    public getColor(): CardColor {
        return this.color;
    }

    public getName(): CardName {
        return this.name;
    }

    public getValue(): number {
        return this.value;
    }
}



// WEBPACK FOOTER //
// ./src/app/Card.ts